var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 105,
    viewBox: "0 0 125 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M115.778 104.146H8.24649C1.81106 104.146 -2.13661 97.0949 1.22752 91.6088L54.9931 3.92942C58.2059 -1.30981 65.8183 -1.30981 69.0311 3.92942L122.797 91.6088C126.161 97.0948 122.213 104.146 115.778 104.146Z",
    fill: "#FF7145"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0119 87.8564C66.5957 87.8564 70.3117 84.1404 70.3117 79.5566C70.3117 74.9728 66.5957 71.2568 62.0119 71.2568C57.4281 71.2568 53.7121 74.9728 53.7121 79.5566C53.7121 84.1404 57.4281 87.8564 62.0119 87.8564Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.063 25.0122H56.9607C55.5422 25.0122 54.43 26.2308 54.5593 27.6434L57.9166 64.3418C58.0302 65.5832 59.0714 66.5336 60.3181 66.5336H63.7058C64.9524 66.5336 65.9937 65.5834 66.1072 64.3418L69.4645 27.6434C69.5937 26.2308 68.4816 25.0122 67.063 25.0122Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertTriangle);
export default __webpack_public_path__ + "static/media/alert-triangle.08ec993c1ac79459db848a358ebab183.svg";
export { ForwardRef as ReactComponent };